/**
 * Vue Router
 */

import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '../store'
import * as types from '../store/types'
import config from '@/../config/app.json'

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	routes
})

router.beforeEach( (to, from, next) => {
	store.dispatch(types.START_TIMER, config.app.sessionDuration)
	next()
})

export default router


// WEBPACK FOOTER //
// ./src/lib/router/index.js